import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const seen = new Map();
let userId = "";
export const setMonitorUser = (id) => { userId = id || ""; };

// Report once per distinct message per minute; never throw from here.
export function reportError(error, source = "", stack = "") {
  try {
    const message = String(error?.message || error || "Unknown error").slice(0, 1000);
    if (/ResizeObserver loop|Loading chunk|Script error\.?$/.test(message)) return;
    const key = `${source}|${message}`;
    const now = Date.now();
    if (seen.get(key) && now - seen.get(key) < 60000) return;
    seen.set(key, now);
    if (seen.size > 200) seen.delete(seen.keys().next().value);
    axios.post(`${API}/client-errors`, {
      message, source: source.slice(0, 200), stack: String(stack || error?.stack || "").slice(0, 6000),
      url: window.location.href.slice(0, 500), user_agent: navigator.userAgent.slice(0, 300), user_id: userId,
    }, { timeout: 5000 }).catch(() => {});
  } catch { /* swallow */ }
}

export function installMonitor() {
  window.addEventListener("error", (e) => reportError(e.error || e.message, "window.error"));
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    if (r?.isAxiosError) return; // API errors are surfaced where they happen
    reportError(r, "unhandledrejection");
    toast.error("Something unexpected happened — it has been reported.", { id: "unhandled" });
  });
}

// Small hook-free helpers for polling: back off when errors pile up, pause when the tab is hidden.
export function makePoller(fn, { base = 3000, max = 30000 } = {}) {
  let delay = base, timer = null, stopped = false;
  const tick = async () => {
    if (stopped) return;
    if (document.visibilityState === "hidden") { timer = setTimeout(tick, Math.max(base, 10000)); return; }
    try { await fn(); delay = base; } catch { delay = Math.min(max, delay * 2); }
    if (!stopped) timer = setTimeout(tick, delay);
  };
  const onVisible = () => { if (document.visibilityState === "visible" && !stopped) { clearTimeout(timer); tick(); } };
  document.addEventListener("visibilitychange", onVisible);
  tick();
  return () => { stopped = true; clearTimeout(timer); document.removeEventListener("visibilitychange", onVisible); };
}
